<template>
  <v-layout fill-height>
    <iframe :src="`${GAME_RELEASE_URL}?token=${token}&amp;locale=${$i18n.locale}`" style="display: block;width: 100%;height:100%;border-top-width: 0px;border-right-width: 0px;border-bottom-width: 0px;border-left-width: 0px;" allow="fullscreen"></iframe>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { GAME_RELEASE_URL } from '@/common/config'

export default {
  name: 'play',
  data () {
    return {
      GAME_RELEASE_URL: GAME_RELEASE_URL
    }
  },
  computed: {
    ...mapGetters(['darkTheme']),
    ...mapGetters('auth', ['isAuthenticated', 'token', 'currentUser', 'isLoading'])
  }
}
</script>
